<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>场馆监管系统系统</el-breadcrumb-item>
        <el-breadcrumb-item>游泳馆</el-breadcrumb-item>
        <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="消费状态：" prop="status">
              <el-select
                size="small"
                v-model="listParams.status"
                style="width: 100%;"
                clearable
              >
                <el-option value="01" label="未消费"></el-option>
                <el-option value="02" label="已消费"></el-option>
                <el-option value="03" label="已退款"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="手机号：" prop="buyerMobile">
              <el-input
                v-model="listParams.buyerMobile"
                size="small"
                style="width: 100%;"
                placeholder="请输入预定手机号"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item label="日期查询：" prop="timeInterval">
              <date-picker-group
                v-model="listParams.timeInterval"
              ></date-picker-group>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData">
                查询
              </el-button>

              <el-button size="small" @click="resetForm('listForm')"
                >重置</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result
      :page-info="pager"
      :loading="tableLoading"
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange"
    >
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px;">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column prop="payTime" align="center" label="下单日期">
          <template slot-scope="scope">
            {{ scope.row.payTime | formatDate }}
          </template>
        </el-table-column>

        <el-table-column prop="buyerName" align="center" label="买家信息">
        </el-table-column>

        <el-table-column prop="productName" align="center" label="购买信息">
        </el-table-column>

        <el-table-column prop="buyAmount" align="center" label="购买数量">
        </el-table-column>

        <el-table-column prop="orderAmount" align="center" label="订单金额">
        </el-table-column>

        <el-table-column
          prop="paymentChannelDisplay"
          align="center"
          label="支付方式"
        >
        </el-table-column>

        <el-table-column prop="status" align="center" label="订单状态">
          <template slot-scope="scope">
            <span v-show="scope.row.status === '01'">未消费</span>
            <span v-show="scope.row.status === '02'">已消费</span>
            <span v-show="scope.row.status === '03'">已退款</span>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        stadiumType: "",
        status: "",
        buyerMobile: "",
        timeInterval: ["", ""]
      },
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0
      }
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    /**
     * 加载列表数据
     */
    loadTableData() {
      const bodyParams = Object.assign({}, this.listParams, {
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize
      });
      bodyParams.stadiumType = parseInt(this.$route.params.stadiumType);
      bodyParams.payTimeStart = bodyParams.timeInterval[0];
      bodyParams.payTimeEnd = bodyParams.timeInterval[1];
      delete bodyParams.timeInterval;
      this.$http({
        url: global.apiUrl + "/stadiumManage/order/list",
        method: "GET",
        params: bodyParams
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            this.pager.total = res.body.data.total;
            if (res.body.data && res.body.data.dataList.length > 0) {
              this.tableData = res.body.data.dataList;
            } else {
              this.tableData = [];
            }
          } else {

            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 重置表单
     * @param name
     */
    resetForm(name) {
      this.$refs[name].resetFields();
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    }
  }
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
